import React, { useEffect } from "react";
import Input from "../../../../components/Input";
import Button from "../../../../components/Button";

const Extra = ({options, setOptions}) => {
    const base = {
        description: ''
    };

    useEffect(() => {
        if(options.length === 0){
            setOptions([base]);
        }
    }, []);

    const addOptions = () => {
        let toOptions = [...options];
        toOptions.push(base);
        setOptions(toOptions);
    }

    const deleteOption = index => {
        let toOptions = [];
        options.map((option, i) => {
            if(index !== i) toOptions.push(option);
        });
        setOptions(toOptions);
    }

    return (
        <>
            {options.map((option, index) => (
                <div key={index} className="section">
                    <div className="row">
                        <div className="col-11">
                            <Input 
                                type={`text`} 
                                label={`Descrição`} 
                                value={option.description}
                                change={value => setOptions(prev => {
                                    prev[index].description = value;
                                    return [...prev];
                                })}
                            />
                        </div>
                        <div className="col-1 variable-option-delete">
                            <Button type={`delete`} svg={`delete-small`} action={() => deleteOption(index)} />
                        </div>
                    </div>
                </div>
            ))}

            <Button 
                type={`link`}
                size={`small`}
                text={`Cadastrar mais opções`}
                full={true}
                action={addOptions}
            />
        </>
    );
}

export default Extra;